<template>
   <div>
      <v-container>
         <v-toolbar dense :color="$globalstore.secondary_titleclass" bottom>
            <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
               Attendance Status - {{ eventdate }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="indigo" class="white" outlined @click="goBack()">
               Back
            </v-btn>
         </v-toolbar>
         <v-card flat outlined class="overflow-y-auto">
            <v-data-table
               dense
               :headers="attendance_headers"
               :items="attenddata"
               item-key="school_id"
               single-select
               @click:row="attendanceRowClick"
            >
               <!-- eslint-disable-next-line -->
               <template #item.actions="{ item }">
                  <div v-if="$globalstore.UserHasCap(CapConstant.MODIFY_ATTENDANCE)">
                     <v-icon small @click="editAttendance(item)">mdi-pencil </v-icon>
                     <v-icon
                        v-if="item.attendstatus == 1 || item.attendstatus == 0"
                        small
                        @click="clearAttendance(item)"
                        class="ml-2"
                        >mdi-delete
                     </v-icon>
                  </div>
               </template>
            </v-data-table>
         </v-card>
         <template>
            <v-container>
               <v-dialog
                  v-model="modal"
                  persistent
                  width="450px"
                  height="200px"
                  @keydown.esc="cancelAttendanceChange"
               >
                  <v-sheet height="200px">
                     <v-row>
                        <v-col cols="12" md="12">
                           <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                              <v-toolbar-title>Modify Attendance</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn @click.stop="cancelBtnClick" class="mx-2">
                                 Cancel
                              </v-btn>
                              <v-btn @click.stop="OkBtnClick" class="mx-2">
                                 OK
                              </v-btn>
                           </v-toolbar>
                        </v-col>
                     </v-row>
                     <v-row justify="space-around">
                        <v-col cols="10" md="8">
                           <v-form ref="attendform" v-model="formvalid">
                              <v-select
                                 :items="attendstatus_select"
                                 v-model="attendstatus"
                                 item-text="text"
                                 item-value="id"
                                 label="Atttendance"
                                 return-object
                                 required
                                 :rules="[(v) => !!v || 'Attendance is required']"
                              >
                              </v-select>
                           </v-form>
                        </v-col>
                     </v-row>
                  </v-sheet>
               </v-dialog>
            </v-container>
         </template>
         <show-toast ref="toast"></show-toast>
         <confirm-dlg ref="confirm"></confirm-dlg>
      </v-container>
   </div>
</template>

<script>
   import CapConstant from "@/common/capconstant.js";
   import {Attendance} from "@/common/constant.js";
   import showToast from "@/components/showToast.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";

   export default {
      inject: ["ShowMessage"],

      components: {showToast, ConfirmDlg},

      props: {
         cca_id: [Number, String],
         eventid: Number,
         eventdate: String,
      },

      data() {
         return {
            CapConstant: Object.freeze(CapConstant),
            Attendance: Object.freeze(Attendance),
            modal: false,
            formvalid: true,
            attenddata: [],
            attendstatus_select: [
               {id: 0, text: "Absent"},
               {id: 1, text: "Present"},
            ],
            attendance_headers: [
               {
                  text: "Student",
                  value: "fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Status",
                  value: "attendstatustext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "submitdate",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Submit By",
                  value: "user_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            attendstatus: null,
            selected_schoolid: -1,
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         attendanceRowClick(item, row) {
            row.select(!row.isSelected);
         },

         cancelBtnClick() {
            this.modal = false;
         },

         editAttendance(item) {
            if (item.attendstatus == Attendance.ABSENT || item.attendstatus == Attendance.PRESENT) {
               this.attendstatus = this.attendstatus_select.find((x) => x.id == item.attendstatus);
            } else {
               this.attendstatus = null;
            }
            this.selected_schoolid = item.school_id;
            this.modal = true;
         },

         clearAttendance(item) {
            this.$refs.confirm
               .open("Warning", "Are you sure you want clear the selected attendance status?", {
                  color: "orange",
                  noconfirm: false,
               })
               .then((reply) => {
                  if (reply) {
                     this.doClearAttendance(item);
                  }
               });
         },

         async doClearAttendance(item) {
            await this.$http({
               url: "/cca/updateattendance.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  cca_id: this.cca_id,
                  eventid: this.eventid,
                  // -1: delete the attendance record
                  attend: -1,
                  schoolid: item.school_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.loadAttendance();
                  }
               }
            });
         },

         OkBtnClick() {
            if (this.$refs.attendform.validate()) {
               this.doUpdateAttendance();
            }
         },

         async doUpdateAttendance() {
            if (this.attendstatus) {
               await this.$http({
                  url: "/cca/updateattendance.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.cca_id,
                     eventid: this.eventid,
                     attend: this.attendstatus.id,
                     schoolid: this.selected_schoolid,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  console.log("response := ", response);
                  this.modal = false;
                  this.selected_schoolid = -1;

                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.$refs.toast.display({
                           message: response.data.message,
                           color: this.$globalstore.toast_successclass,
                        });
                        this.loadAttendance();
                     }
                  }
               });
            }
         },

         async loadAttendance() {
            await this.$http({
               url: "/cca/getattendancebyeventid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  eventid: this.eventid,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) this.$globalstore.user.tokenexpired = true;
               else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.attenddata = response.data.attenddata;
                  }
               }
            });
         },
      },
      mounted() {
         this.loadAttendance();
      },
   };
</script>
